import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"

const FeedbackBtns = props => {
    const { onFeedbackClick, onContactClick } = props
    const { t } = useTranslation()
    return <div className='feedback'>
        <div style={styles.feedbackBtn} onClick={onFeedbackClick}>
            <img src={`${CommonUtil.getSourceDomain()}feedback_icon.png`} alt="" style={{ width: 24, height: 24 }} />
            <span style={{ fontSize: 15, color: '#4C4C4C', fontWeight: '500', marginLeft: 5 }}>{t('feedback')}</span>
        </div>
        <div style={styles.contactBtn} onClick={onContactClick}>
            <img src={`${CommonUtil.getSourceDomain()}contact_icon.png`} alt="" style={{ width: 24, height: 24 }} />
            <span style={{ fontSize: 15, color: '#FFFFFF', fontWeight: '500', marginLeft: 5 }}>{t('cancat')}</span>
        </div>
    </div>
}

const styles = {
    feedbackBtn: {
        height: 48,
        width: 157,
        background: '#FFFFFF',
        borderRadius: 87,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    },
    contactBtn: {
        height: 48,
        width: 157,
        background: '#896AFF',
        borderRadius: 87,
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'center',
        alignItems: 'center'
    }
}

export default FeedbackBtns